import React, { useEffect, useState } from "react";
import ConfirmDialog from "../../../../components/actionDialogs/confirmDialog";
import Loader from "../../../../components/loader/loader";
import Snackbar from "../../../../components/snackbar/snackbar";
import CustomTable from "../../../../components/table/table";
import {
  admin_banners_list,
  admin_banner_delete,
  admin_areatype_delete,
  admin_rentarea_list,
  admin_rentarea_delete,
} from "../../admin.api";
import ManageBanner from "./manage/manage";
import "./view.css";
import jwtDecode from "jwt-decode";
export default function View(props) {
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const [data, setdata] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [formData, setFormData] = useState({});
  const [edit, setEdit] = useState(false);
  const [view, setView] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [rentArea, setRentArea] = useState([]);

  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  //////////
  const fetchRentArea = () => {
    setIsActive(true);
    admin_rentarea_list()
      .then((res) => {
        const tdata = res?.map((item) => ({
          id: item.id,
          building_name: item.building_name,
          floor_name: item.floor_name,
          rentable_area_sqft: item.rentable_area_sqft,
        }));
        setRentArea(tdata);
      })
      .finally(() => {
        setIsActive(false);
      });
  };

  useEffect(() => {
    fetchRentArea();
  }, []);
  const handleAddNew = () => {
    setAddNew(true);
    setView(false);
  };
  const handleClose = () => {
    setAddNew(false);
    setEdit(false);
    setFormData({});
    fetchRentArea();
  };
  const handleEdit = (data) => {
    setFormData(data);
    setView(false);
    setEdit(true);
    setAddNew(true);
  };
  const handleView = (data) => {
    setAddNew(true);
    setFormData(data);
    setView(true);
  };
  //for delete
  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_rentarea_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsActive(false);
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setIsActive(false);
        setSnackOpen(true);
      });
  };
  /////////////////////
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      fetchRentArea();
    }
  };
  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Building & Floor Details</b>
        </h6>
        <hr />
        {adminType === 1 && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={(e) => handleAddNew(e)}
          >
            Add New
          </button>
        )}

        <CustomTable
          {...props}
          columns={[
            { title: "Building Name", field: "building_name" },
            { title: "Floor Name", field: "floor_name" },
            { title: "Rentable Area ", field: "rentable_area_sqft" },
          ]}
          data={rentArea || []}
          actions={
            adminType === 2
              ? [
                  { type: "view", handleClick: handleView },
                  { type: "delete", handleClick: handleDelete },
                ]
              : [
                  { type: "view", handleClick: handleView },
                  { type: "edit", handleClick: handleEdit },
                ]
          }
        />
      </div>
      {addNew && (
        <ManageBanner
          open={addNew}
          edit={edit}
          view={view}
          handleClose={handleClose}
          formData={formData}
        />
      )}
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Area ?"
          data={activeData}
          message="Are you sure to Delete this Area?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
